
namespace Matrix.Workflow {

    export interface ClientFunctionParamDef {
        Name: string;
        Type?: string;
        DefaultValue?: string;
        Required?: boolean;
        Size?: number;
        Scale?: number;
    }

    @Serenity.Decorators.registerClass()
    export class ClientFunctionTriggerDialog extends SiteEntityDialog<ClientFunctionTriggerRow, any> {
        protected getFormKey() { return ClientFunctionTriggerForm.formKey; }
        protected getIdProperty() { return ClientFunctionTriggerRow.idProperty; }
        protected getLocalTextPrefix() { return ClientFunctionTriggerRow.localTextPrefix; }
        protected getNameProperty() { return ClientFunctionTriggerRow.nameProperty; }
        protected getService() { return ClientFunctionTriggerService.baseUrl; }

        protected form = new ClientFunctionTriggerForm(this.idPrefix);

        constructor() {
            super();

            this.form.FunctionName.changeSelect2(() => {
                var functionName = this.form.FunctionName.value;
                if (functionName) {
                    var func = ClientFunctionRow.getLookup().itemById[functionName];
                    if (func != null && func.Parameters != null) {
                        var prm = func.Parameters.trim();
                        if (prm.charAt(0) == '[' && prm.charAt(prm.length - 1) == ']') {
                            var prmList = JSON.parse(prm) as ClientFunctionParamDef[];
                            var params: ClientFunctionTriggerParameter[] = prmList.map(ClientFunctionTriggerDialog.mapClientFunctionDefToParam);
                            this.form.ParameterList.value = params;
                        }
                    }
                }
                
            });

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        static mapClientFunctionDefToParam(def: ClientFunctionParamDef) {
            var prm: ClientFunctionTriggerParameter = {
                Name: def.Name,
                Title: titleize(def.Name || ""),
                DefaultValue: def.DefaultValue,
                Required: !!def.Required,
                Visible: true
            };

            switch ((def.Type || "").toLowerCase()) {
                case "string":
                    prm.Type = Data.DataType.String;
                    break;
                case "int16":
                    prm.Type = Data.DataType.Int16;
                    break;
                case "int32":
                    prm.Type = Data.DataType.Int32;
                    break;
                case "int64":
                    prm.Type = Data.DataType.Int64;
                    break;
                case "boolean":
                    prm.Type = Data.DataType.Boolean;
                    break;
                case "decimal":
                    prm.Type = Data.DataType.Decimal;
                    break;
                case "single":
                    prm.Type = Data.DataType.Single;
                    break;
                case "double":
                    prm.Type = Data.DataType.Double;
                    break;
                case "date":
                    prm.Type = Data.DataType.Date;
                    break;
                case "time":
                    prm.Type = Data.DataType.Time;
                    break;
                case "datetime":
                    prm.Type = Data.DataType.DateTime;
                    break;
                case "guid":
                    prm.Type = Data.DataType.Guid;
                    break;
                default:
                    prm.Type = Data.DataType.String;
                    break;
            }

            switch (prm.Type) {
                case Data.DataType.Decimal:
                case Data.DataType.Double:
                case Data.DataType.Int16:
                case Data.DataType.Int32:
                case Data.DataType.Int64:
                case Data.DataType.Single:
                case Data.DataType.String:
                    prm.Size = def.Size != null ? Math.max(def.Size, 0) : null;
            }

            switch (prm.Type) {
                case Data.DataType.Decimal:
                case Data.DataType.Double:
                case Data.DataType.Single:
                case Data.DataType.String:
                    prm.Scale = def.Scale != null ? Math.max(def.Scale, 0) : null;
            }

            switch (prm.Type) {
                case Data.DataType.Boolean:
                    prm.EditorType = "Boolean";
                    break;

                case Data.DataType.Date:
                    prm.EditorType = "Date";
                    break;

                case Data.DataType.DateTime:
                    prm.EditorType = "DateTime";
                    break;

                case Data.DataType.Decimal:
                case Data.DataType.Double:
                case Data.DataType.Single:
                    prm.EditorType = "Decimal";
                    break;

                case Data.DataType.Int16:
                case Data.DataType.Int32:
                case Data.DataType.Int64:
                    prm.EditorType = "Integer";
                    break;

                default:
                    prm.EditorType = "String";
                    break;
            }

            return prm;
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }

        protected arrange() {
            super.arrange();
            var availHeight = $(window).height() - 270;
        }

        useViewMode() {
            return false;
        }

        afterLoadEntity() {
            super.afterLoadEntity();
        }
    }
}